module.exports = __webpack_public_path__ + "static/img/04952403.b75a417d.png";